import { useState } from "react";

const ConfigureColumns = ({ show, onClose, onSave, initialFields }) => {
    const [fields, setFields] = useState(initialFields);

    const toggleFieldSelection = (index) => {
        const newFields = [...fields];
        newFields[index].selected = !newFields[index].selected;
        setFields(newFields);
    };

    const handleSave = () => {
        onSave(fields);
        onClose();
    };

    if (!show) return null;

    return (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">
                    <div className="modal-header pb-0" style={{borderBottom:'0px'}}>
                        <div>
                        <h5 className="modal-title" style={{fontSize:'19px'}}>GRN Fields</h5>
                        <h6 className="" style={{fontSize:'13px',color:'#686666'}}>+ Add / Remove Fields</h6>
                        </div>
                        <button type="button" className="btn-close" style={{fontSize:'13px',position:"relative",top:"-12px"}} onClick={onClose}></button>
                    </div>
                    <div className="modal-body p-0">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12 pt-4">
                                    <div className="row">
                                        {fields.map((field, index) => (
                                            <div key={index} style={{display:field.key == "settings" ? "none" : ""}} className="col-md-4 mb-2">
                                                <div 
                                                    className={`d-flex align-items-center px-1`}
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => toggleFieldSelection(index)}
                                                >
                                                    <input 
                                                        type="checkbox" 
                                                        style={{fontSize:'13px',backgroundColor:'#270B79',borderColor:"#270B79"}}
                                                        className="form-check-input me-2" 
                                                        checked={field.selected}
                                                        onChange={() => {}}
                                                    />
                                                    <span style={{fontSize:'14px'}}>{field.name}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer" style={{borderTop:"0px"}}>
                        <p 
                            className="createbtn m-0"
                            onClick={handleSave}
                        >
                            Save
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfigureColumns;